import { BigCheckmark } from "@circle-react-shared/BigCheckmark";
import { BigCross } from "@circle-react-shared/BigCross";
import { BigSpinner } from "@circle-react-shared/BigSpinner";
import type { ReactNode } from "react";

type Variant = "loading" | "success" | "error";

export interface StatusIconProps {
  animate?: boolean;
  icon?: ReactNode;
  variant: Variant;
}

const variantIcons: Record<Variant, (animate?: boolean) => ReactNode> = {
  loading: animate => <BigSpinner animate={animate} />,
  success: () => <BigCheckmark />,
  error: () => <BigCross />,
};

export const StatusIcon = ({ variant, icon, animate }: StatusIconProps) => {
  if (icon) return <>{icon}</>;
  const RenderIcon = variantIcons[variant];
  return <>{RenderIcon?.(animate)}</>;
};
